<template>
  <!--==================
        component for update password (admin, operator)
        ===============-->

  <div class="col-md-8 pb-20 pt-20">
    <!-- last user update password time -->
    <p class="text-gray-800"><i class="icofont-history"></i> Last password update: {{ lastPasswordUpdate }}</p>

    <!-- update password form -->
    <form @submit.prevent="updatePass" ref="userForm">
      <div class="form-group">
        <input
          @input="$v.form.pass.$touch()"
          class="form-control form-control-sm"
          type="password"
          name="pass"
          v-model="form.pass"
          placeholder="current password"
        />
        <span class="text-danger" v-if="$v.form.pass.$dirty && !$v.form.pass.required">
          &nbsp; This field is required
        </span>
      </div>
      <div class="form-group">
        <input
          @input="$v.form.pass1.$touch()"
          class="form-control form-control-sm"
          type="password"
          name="pass1"
          v-model="form.pass1"
          placeholder="new password"
        />
        <span class="text-danger" v-if="$v.form.pass1.$dirty && !$v.form.pass1.required">
          &nbsp; This field is required
        </span>
        <span class="text-danger" v-if="$v.form.pass1.$dirty && $v.form.pass1.required && !$v.form.pass1.minLength">
          &nbsp; Field must have at least 8 characters
        </span>
        <span class="text-danger" v-if="$v.form.pass1.$dirty && $v.form.pass1.minLength && !$v.form.pass1.passRegex">
          &nbsp; Password is too weak
        </span>
      </div>
      <div class="form-group">
        <input
          @input="$v.form.pass2.$touch()"
          class="form-control form-control-sm"
          type="password"
          name="pass2"
          v-model="form.pass2"
          placeholder="confirm password"
        />
        <span class="text-danger" v-if="$v.form.pass2.$dirty && !$v.form.pass2.required">
          &nbsp; This field is required
        </span>
        <span
          class="text-danger"
          v-if="$v.form.pass2.required && !$v.form.pass1.$invalid && !$v.form.pass2.sameAsPassword"
        >
          &nbsp; Password not match
        </span>
      </div>
      <div class="form-group text-center">
        <button class="btn btn-sm btn-success col-md-6" type="submit" :disabled="submitForm || $v.form.$invalid">
          <span v-if="!submitForm">UPDATE</span>
          <span v-if="submitForm" class="ml-2">updatting...</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { passRegex } from "@/validator";
const dateFormat = require("dateformat");

export default {
  name: "UpdatePassword",

  data() {
    return {
      submitForm: false,
      form: {},
      errors: {},
    };
  },

  computed: {
    ...mapGetters(["operator", "user"]),

    lastPasswordUpdate() {
      if (this.operator.passwordUpdate) {
        return dateFormat(this.operator.passwordUpdate, "mmm dS, yyyy, h:MM:ss TT");
      } else {
        return "Never";
      }
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchOperator(this.user.id);
      this.hideBarLoading();
    });
  },

  validations() {
    return {
      form: {
        pass: { required },
        pass1: { required, passRegex, minLength: minLength(8) },
        pass2: {
          required,
          sameAsPassword: sameAs("pass1"),
        },
      },
    };
  },

  methods: {
    ...mapActions([
      "fetchOperator",
      "userPasswordUpdate",
      "hideBarLoading",
      "showSpinnerLoading",
      "hideSpinnerLoading",
    ]),

    async updatePass() {
      this.showSpinnerLoading();
      this.submitForm = true;

      const formData = new FormData(this.$refs.userForm);
      const data = Object.fromEntries(formData.entries());

      const submitData = {
        email: this.user.username,
        currentPassword: data.pass,
        newPassword: data.pass1,
      };

      await this.userPasswordUpdate(submitData)
        .then((res) => {
          this.hideSpinnerLoading();
          this.$v.$reset();
          this.form = {};
          this.submitForm = false;

          if (res.data.statusCode == 401) {
            $.alert("invalid credentials");
          } else {
            $.alert("password updated successfull");
          }
        })
        .catch(() => {
          this.hideSpinnerLoading();
          this.submitForm = false;

          $.alert("submision failed!");
        });
    },
  },
};
</script>
